import { Box, Button, Typography } from "@mui/material";
import { ReactElement, useState } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import { PartialSendDialog } from "~frontend/routes/subaccounts/campaignView/initialSend/PartialSendDialog";
import { palette } from "~frontend/theme";

import { CampaignForView } from "../types";

export default function PartialSendEvaluationPending({
  campaign,
}: {
  campaign: CampaignForView;
}): ReactElement {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <Box>
      <FlexBox gap={1} sx={{ mt: 1, mb: 2 }}>
        <Button variant="contained" fullWidth disabled>
          Full Send
        </Button>
        <Button variant="contained" fullWidth disabled>
          Partial Send
        </Button>
      </FlexBox>
      <Typography variant="body2" color={palette.darkGray} sx={{ mb: 2 }}>
        There is a partial send currently running on this campaign. You can not
        send or schedule the rest of your messages unless the send is
        canceled.{" "}
      </Typography>
      <Button onClick={() => setShowDialog(true)} fullWidth variant="contained">
        View or cancel send
      </Button>
      {showDialog && (
        <PartialSendDialog
          campaign={campaign}
          handleClose={() => setShowDialog(false)}
        />
      )}
    </Box>
  );
}
